import React from 'react';
import { DetailedProgramPageContent } from './components/detailed-program-page-content/DetailedProgramPageContent';

export const DetailedProgramPage: React.FC = () => {
    return <DetailedProgramPageContent />;
};
